<template>
  <div class="loader-wrapper" :class="{'active': active, 'update': update, 'small': small}">
    <div class="loader-container">
      <div class="loader-cube">
        <div id="cube">
          <div class="front"></div>
          <div class="back"></div>
          <div class="right"></div>
          <div class="left"></div>
          <div class="top"></div>
          <div class="bottom"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheLoader',
  props: {
    active: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    },
    small: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      }
    },
    update: {
      required: false,
      default: () => {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheLoader.vue